import * as permission from 'common-module/src/config/permission';
export const imMap = {
  fei_shu: permission.integrationFeiShu,
  work_wechat: permission.integrationWechat,
  slack: permission.integrationSlack,
  ding_talk: permission.integrationDingTalk
};
